<template>
       <div class="remind contains">
         <div  class="content-tit">
            <h2>自动提醒</h2>
         </div>
         <div class="content-main">
            <div class="flex-box">
              <div class="box">
                  <AutoReplyForm :obj="autoList.find(d=>d.id==1)" @onSuccess="UpdateAutoReply"/>
              </div>
              <!-- <div class="box">
                <div class="re-title">新开对话自动发送欢迎语</div>
                <div class="option">
                   <div class="lable">是否开启:</div>
                   <div class="flex-content">
                     <el-switch
                       v-model="Model1.isTrue"
                       active-text="开启">
                     </el-switch>
                   </div>
                </div>
                <div class="option">
                  <div class="lable">自动回复内容：</div>
                  <div class="flex-content">
                    <el-input type="textarea" class="textarea" v-model="Model1.content.content"
                              placeholder="请输入内容" resize="none"></el-input>
                  </div>
                </div>
                <div class="option special">
                  <el-button>取消</el-button>
                  <el-button type="primary" @click="Update(1,'自动发送欢迎语设置')">保存</el-button>
                </div>
              </div> -->

              <div class="box">
                <div class="re-title">长时间没有反应发送提示语</div>
                <div class="option">
                  <div class="lable">是否开启:</div>
                  <div class="flex-content">
                    <el-switch
                      v-model="Model2.isTrue"
                      active-text="开启">
                    </el-switch>
                  </div>
                </div>
                <div class="option">
                  <div class="lable">设置自动回复时间：</div>
                  <div class="flex-content">
                    <el-input v-model="Model2.content1.content"></el-input> 秒
                  </div>
                </div>
                <div class="option">
                  <div class="lable">自动结束会话：</div>
                  <div class="flex-content">
                    <el-input  v-model="Model2.content2.content"></el-input> 秒
                  </div>
                </div>
                <div class="option">
                  <div class="lable">自动回复内容：</div>
                  <div class="flex-content">
                    <el-input type="textarea" class="textarea"
                    v-model="Model2.content.content"
                              placeholder="请输入内容" resize="none"></el-input>
                  </div>
                </div>
                <div class="option special">
                  <el-button>取消</el-button>
                  <el-button type="primary" @click="Update(2,'长时间没有反应发送提示语设置')">保存</el-button>
                </div>
              </div>
              <div class="box">
                <div class="re-title">客服结束语</div>
                <div class="option">
                  <div class="lable">是否开启:</div>
                  <div class="flex-content">
                    <el-switch
                      v-model="Model3.isTrue"
                      active-text="开启">
                    </el-switch>
                  </div>
                </div>
                <div class="option">
                  <div class="lable">自动回复内容：</div>
                  <div class="flex-content">
                    <el-input type="textarea" class="textarea"
                    v-model="Model3.content.content"
                              placeholder="请输入内容" resize="none"></el-input>
                  </div>
                </div>
                <div class="option special">
                  <el-button>取消</el-button>
                  <el-button type="primary" @click="Update(3,'客服结束语设置')">保存</el-button>
                </div>
              </div>
              <div class="box">
                <div class="re-title">排队提示语</div>
                <div class="option">
                  <div class="lable">是否开启:</div>
                  <div class="flex-content">
                    <el-switch
                      v-model="Model4.isTrue"
                      active-text="开启">
                    </el-switch>
                  </div>
                </div>
                <div class="option">
                  <div class="lable">排队超时时间</div>
                  <div class="flex-content">
                    <el-input v-model="Model4.content1.content"></el-input> 秒
                  </div>
                </div>
                <div class="option">
                  <div class="lable">超时提示语</div>
                  <div class="flex-content">
                 
                                        <el-input type="textarea" class="textarea"
                    v-model="Model4.content2.content"
                              placeholder="请输入内容" resize="none"></el-input>
                  </div>
                </div>
                <div class="option">
                  <div class="lable">自动回复内容：</div>
                  <div class="flex-content">
                    <el-input type="textarea" class="textarea"
                    v-model="Model4.content.content"
                              placeholder="请输入内容" resize="none"></el-input>
                  </div>
                </div>
                <div class="option special">
                  <el-button>取消</el-button>
                  <el-button type="primary" @click="Update(4,'超时时间设置')">保存</el-button>
                </div>
              </div>

            </div>

         </div>
       </div>
</template>

<script>
import { Base64 } from 'js-base64';
import AutoReplyForm from './autoReplyFrom.vue'
export default {
        name:'remind',
        props: [],
        data () {
           return{
             value1:'',
             Model:[],
             Model1:{
               id:0,
               isTrue:false,
               content:{
                 id:0,
                 content:''
               } 
             },
             Model2:{
                id:0,
                isTrue:false,
               content:{
                  id:0,
                 content:''
               },
               content1:{
                 id:'',
                 content:''
               },
               content2:{
                   id:'',
                 content:''
               }
             },
             Model3:{
                id:0,
                isTrue:false,
                 content:{
                     id:'',
                 content:''
                 }
             },
             Model4:{
                id:0,
                isTrue:false,
               content:{
                  id:0,
                 content:''
               },
               content1:{
                 id:'',
                 content:''
               },
               content2:{
                   id:'',
                 content:''
               }
             },
             autoList:[]
           
           }
        },
        components:{
          AutoReplyForm
        },
        watch: {},
        mounted: function () {
            this.show();
        },
        methods: {
          show(){
              let $this=this;
            
              this.axios.get('AutoContent/List',
              {headers:{
                'Content-Type':'application/json'
              }})
              .then(function(data){
              $this.autoList=$this.integrateData(data.data);
              $this.loading=false;
              console.log($this.autoList)
                data.data.forEach(element => {
                  if(element.title=="新开对话自动发送欢迎语"){
                    $this.Model1.title=element.title;
                      $this.Model1.id=element.id;
                      $this.Model1.isTrue=element.isTrue;
                      element.list.forEach(element1 => {
                        if(element1.name=="回复内容"){
                          $this.Model1.content.id=element1.id;
                          $this.Model1.content.content=element1.content;
                        }
                      });
                  }
                  else if(element.title=="长时间没有反应发送提示语"){
                    $this.Model2.title=element.title;
                        $this.Model2.id=element.id;
                      $this.Model2.isTrue=element.isTrue;
                      element.list.forEach(element1 => {
                        if(element1.name=="回复内容"){
                            $this.Model2.content.id=element1.id;
                          $this.Model2.content.content=element1.content;
                        }
                        else if(element1.name=="自动回复时间"){
                            $this.Model2.content1.id=element1.id;
                            $this.Model2.content1.content=element1.content;
                        }
                        else if(element1.name=="自动结束时间"){
                            $this.Model2.content2.id=element1.id;
                            $this.Model2.content2.content=element1.content;
                        }
                      });
                  }
                  else if(element.title=="客服结束语"){
                      $this.Model3.title=element.title;
                        $this.Model3.id=element.id;
                      $this.Model3.isTrue=element.isTrue;
                      element.list.forEach(element1 => {
                        if(element1.name=="自动结束时间"){
                          $this.Model3.content.id=element1.id;
                          $this.Model3.content.content=element1.content;
                        }
                      });
                  }
                  else if(element.title=="排队提示语"){
                        $this.Model4.title=element.title;
                        $this.Model4.id=element.id;
                      $this.Model4.isTrue=element.isTrue;
                      element.list.forEach(element1 => {
                        if(element1.name=="回复内容"){
                            $this.Model4.content.id=element1.id;
                          $this.Model4.content.content=element1.content;
                        }
                        else if(element1.name=="排队超时时间"){
                            $this.Model4.content1.id=element1.id;
                            $this.Model4.content1.content=element1.content;
                        }
                        else if(element1.name=="超时提示语"){
                            $this.Model4.content2.id=element1.id;
                            $this.Model4.content2.content=element1.content;
                        }
                      });
                  }
                });
              })
          },
          //自动提醒修改
          Update(Type,channel){
              let $this=this;
              channel = Base64.encode(channel)
              if(Type==1){  
                  this.axios.post("AutoContent/UpdateAutoBase?IsTrue="+$this.Model1.isTrue+"&Id="+$this.Model1.id+"&Title="+$this.Model1.title,{
                    headers:{'Content-Type':'application/json',auditChannel:channel}
                  }).then(function(data){
                    if(data.data.message=="成功"){
                      var List=[];
                      List.push($this.Model1.content);
                        $this.axios.post("AutoContent/UpdateAutoContent?name="+$this.Model1.title+"/"+$this.Model1.content.title,List,{
                          headers:{'Content-Type':'application/json'}
                        }).then(function(data1){
                            if(data1.data.message=="成功"){
                              $this.$message(data1.data.message)
                              $this.show();
                            }
                            else{
                              $this.$message.error(data1.data.message)
                            }
                        })
                    }
                    else{
                      $this.$message.error(data.data.message)
                    }
                  })
              }
              else if(Type==2){
                  this.axios.post("AutoContent/UpdateAutoBase?IsTrue="+$this.Model2.isTrue+"&Id="+$this.Model2.id+"&Title="+$this.Model2.title,{
                    headers:{'Content-Type':'application/json',auditChannel:channel}
                  }).then(function(data){
                    if(data.data.message=="成功"){
                      var List=[];
                      List.push($this.Model2.content);
                       List.push($this.Model2.content1);
                        List.push($this.Model2.content2);
                        $this.axios.post("AutoContent/UpdateAutoContent?name="+$this.Model2.title+"/"+$this.Model2.content.title,List,{
                          headers:{'Content-Type':'application/json'}
                        }).then(function(data1){
                            if(data1.data.message=="成功"){
                              $this.$message(data1.data.message)
                              $this.show();
                            }
                            else{
                              $this.$message.error(data1.data.message)
                            }
                        })
                    }
                    else{
                      $this.$message.error(data.data.message)
                    }
                  })
              }
              else if(Type==3){
                  this.axios.post("AutoContent/UpdateAutoBase?IsTrue="+$this.Model3.isTrue+"&Id="+$this.Model3.id+"&Title="+$this.Model3.title,{
                    headers:{'Content-Type':'application/json',auditChannel:channel}
                  }).then(function(data){
                    if(data.data.message=="成功"){
                      var List=[];
                      List.push($this.Model3.content);
                        $this.axios.post("AutoContent/UpdateAutoContent?name="+$this.Model3.title+"/"+$this.Model3.content.title,List,{
                          headers:{'Content-Type':'application/json',auditChannel:channel}
                        }).then(function(data1){
                            if(data1.data.message=="成功"){
                              $this.$message(data1.data.message)
                              $this.show();
                            }
                            else{
                              $this.$message.error(data1.data.message)
                            }
                        })
                    }
                    else{
                      $this.$message.error(data.data.message)
                    }
                  })
              }
               else if(Type==4){
                  this.axios.post("AutoContent/UpdateAutoBase?IsTrue="+$this.Model4.isTrue+"&Id="+$this.Model4.id+"&Title="+$this.Model4.title,{
                    headers:{'Content-Type':'application/json',auditChannel:channel}
                  }).then(function(data){
                    if(data.data.message=="成功"){
                      var List=[];
                      List.push($this.Model4.content);
                       List.push($this.Model4.content1);
                        List.push($this.Model4.content2);
                        $this.axios.post("AutoContent/UpdateAutoContent?name="+$this.Model4.title+"/"+$this.Model4.content.title,List,{
                          headers:{'Content-Type':'application/json'}
                        }).then(function(data1){
                            if(data1.data.message=="成功"){
                              $this.$message(data1.data.message)
                              $this.show();
                            }
                            else{
                              $this.$message.error(data1.data.message)
                            }
                        })
                    }
                    else{
                      $this.$message.error(data.data.message)
                    }
                  })
              }

          },
          /**修改自动回复 */
          UpdateAutoReply(data){
            let $this = this;
            this.axios.post('AutoContent/UpdateAutoReply',data,{headers:{auditChannel:Base64.encode('修改自动回复')}})
            .then(function({data}){
              if(data.result){
                $this.show()
                $this.$message.success(data.message)
              }else{
                $this.$message.error(data.message)
              }
            })
          },
          integrateData(datas){
              let autoReply = []
              let data = datas.find(d=>d.id==1);
              data.list.forEach((item,index)=>{
                 
                  if(item.messageType==2 || item.messageType==3){
                    //  let imgArray = autoReply.filter(d=>d.messageType==2)
                    //  let current = {...item}
                    //  current.content=[];
                    //  let previous =  data.list[index - 1];
                    //  if(imgArray.length==0 ){

                    //     current.content.push({url:item.content,response:{shortHref:item.path},id:item.id});
                    //     autoReply.push(current)

                    //  }else if(imgArray.length>0 && previous.messageType==2) {
                    //     let obj = imgArray[imgArray.length-1]
                    //     let obj2=  autoReply.find(d=>d.id==obj.id);

                    //     obj2.content.push({url:item.content,response:{shortHref:item.path},id:item.id})
              
                    //  }else {
                    //     current.content.push({url:item.content,response:{shortHref:item.path}});

                    //     autoReply.push(current)
                    //  }
                    this.mergeArray(autoReply,item.messageType,data,item,index)
                  }else{
                    autoReply.push(item);
                  }
              })
              data.list = autoReply;
              
              return datas;
          },
          /**
           * 多个对象整合成一个数组
           * autoReply 主数组
           * messageType 消息类型 已有 2 3
           * data 当前循环对象
           * item 当前对象
           */
          mergeArray(autoReply,messageType,data,item,index){
              let imgArray = autoReply.filter(d=>d.messageType==messageType)
              let current = {...item}
              current.content=[];
              let previous =  data.list[index - 1];
              if(imgArray.length==0){
                  current.content.push({url:item.content,response:{shortHref:item.path},id:item.id});
                  autoReply.push(current)
              }else if(imgArray.length>0 && previous.messageType==messageType) {
                  let obj = imgArray[imgArray.length-1]
                  let obj2=  autoReply.find(d=>d.id==obj.id);
                  obj2.content.push({url:item.content,response:{shortHref:item.path},id:item.id})
              }else {
                current.content.push({url:item.content,response:{shortHref:item.path}});
                autoReply.push(current)
             }
          }
        }
    }
</script>

<style scoped>
  .content-tit{
    line-height:40px;
    padding-bottom:5px;
    padding-top:20px;
  }
  .content-tit h2{
    font-size:24px;
    line-height:30px;
    font-weight:normal;
  }
  .flex-box{
    width:100%;
    padding-top:30px;
  }
  .box{
    width:75%;
    padding:30px;
    background-color:#F6F7F9;
    margin-bottom:25px;
  }
  .re-title{
    font-size:18px;
    font-weight: bolder;
  }
  .remind .option{
    display: flex;
    display: -webkit-flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding:10px 0;
  }
  .remind .option.special{
    width:540px;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: flex-end;
  }
  .remind .lable{
    line-height:32px;
    width:140px;
  }
  .remind .flex-content{
    line-height:32px;
    width:400px;
  }
</style>
<style>
  /* .remind .el-textarea__inner{
    background-color:#fff;
    width:400px;
    height:75px;
  } */
  .remind .el-input__inner{
  
    background-color:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/setting/remind.vue